"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PollingMode = void 0;
var PollingMode;
(function (PollingMode) {
    /** @member {string} */
    /** Polling is enabled for all library functions */
    PollingMode["All"] = "All";
    /** @member {string} */
    /** Polling is disabled */
    PollingMode["None"] = "None";
    /** @member {string} */
    /** Polling is only active for button callbacks */
    PollingMode["Callbacks"] = "Callbacks";
    /** @member {string} */
    /** Polling is only active for navigation */
    PollingMode["Navigation"] = "Navigation";
})(PollingMode || (exports.PollingMode = PollingMode = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9sbGluZ01vZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdHlwZXMvcG9sbGluZ01vZGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDREQUE0RDs7O0FBRTVELElBQVksV0FhWDtBQWJELFdBQVksV0FBVztJQUNuQix1QkFBdUI7SUFDdkIsbURBQW1EO0lBQ25ELDBCQUFXLENBQUE7SUFDWCx1QkFBdUI7SUFDdkIsMEJBQTBCO0lBQzFCLDRCQUFhLENBQUE7SUFDYix1QkFBdUI7SUFDdkIsa0RBQWtEO0lBQ2xELHNDQUF1QixDQUFBO0lBQ3ZCLHVCQUF1QjtJQUN2Qiw0Q0FBNEM7SUFDNUMsd0NBQXlCLENBQUE7QUFDN0IsQ0FBQyxFQWJXLFdBQVcsMkJBQVgsV0FBVyxRQWF0QiJ9